import { render, staticRenderFns } from "./templates.index.component.vue?vue&type=template&id=ad8d268c&scoped=true&"
import script from "./templates.index.component.vue?vue&type=script&lang=js&"
export * from "./templates.index.component.vue?vue&type=script&lang=js&"
import style0 from "./templates.index.component.vue?vue&type=style&index=0&id=ad8d268c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8d268c",
  null
  
)

export default component.exports